import gql from 'graphql-tag';

export interface UploadReplyInput {
  fileName?: string;
  dataUrl?: string;
  fileLink?: string;
  variantId?: number;
  assessmentId: number;
}

export const sendAssessmentReplyFile = gql`
  mutation sendAssessmentReplyFile($dexCourseId: Float!, $data: UploadReplyInput!) {
    addFileReply(dexCourseId: $dexCourseId, data: $data) {
      link
    }
  }
`;

export const resetDexAssignment = gql`
  mutation resetDexAssignment($assessmentResultId: Float!, $dexCourseId: Float!) {
    resetDexAssignment(assessmentResultId: $assessmentResultId, dexCourseId: $dexCourseId)
  }
`;

export interface UploadFileInput {
  fileName: string;
  dataUrl: string;
}

export const sendFinalTCC = gql`
  mutation sendFinalTCC(
    $finalTCCFile: UploadFileInput!
    $quizFile: UploadFileInput!
    $assessmentResultId: Float!
    $dexCourseId: Float!
  ) {
    sendFinalTCC(
      dexCourseId: $dexCourseId
      data: {
        finalTCCFile: $finalTCCFile
        quizTCCFile: $quizFile
        assessmentResultId: $assessmentResultId
      }
    ) {
      link
    }
  }
`;

export const sendTCCTheme = gql`
  mutation sendTCCTheme($dexCourseId: Float!, $tccTheme: String!, $assessmentId: Float!) {
    sendTccTheme(
      dexCourseId: $dexCourseId
      data: { theme: $tccTheme, assessmentId: $assessmentId }
    ) {
      type
      status
    }
  }
`;

export const requestTCCRevaluation = gql`
  mutation requestTCCRevaluation(
    $dexCourseId: Float!
    $assessmentResultId: Float!
    $pleadingText: String!
  ) {
    requestTCCRevaluation(
      dexCourseId: $dexCourseId
      assessmentResultId: $assessmentResultId
      pleadingText: $pleadingText
    ) {
      id
    }
  }
`;

export const sendPartialTCC = gql`
  mutation sendPartialTCC(
    $dexCourseId: Float!
    $assessmentResultId: Float!
    $fileName: String!
    $dataUrl: String!
  ) {
    sendPartialTCC(
      assessmentResultId: $assessmentResultId
      fileName: $fileName
      dataUrl: $dataUrl
      dexCourseId: $dexCourseId
    ) {
      id
      status
    }
  }
`;

export const startTCCRetry = gql`
  mutation startTCCRetry($assessmentId: Float!, $dexCourseId: Float!, $useSameTheme: Boolean!) {
    startTCCRetry(
      dexCourseId: $dexCourseId
      data: { useSameTheme: $useSameTheme, assessmentId: $assessmentId }
    ) {
      id
      status
    }
  }
`;
